import React from "react";
import { observer } from "mobx-react-lite";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { ServiceAccountList } from "./list";
import { ServiceAccountCreate } from "./create/create";
import { ServiceAccountDetailRoute } from "./detailRoute";
import { ConsoleContext } from "../../mobxStores/consoleContext/consoleContext";

const ServiceaccountRoute: React.FC = () => {
  const { org } = ConsoleContext;

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<ServiceAccountList />} />
        <Route path={`-create/*`} element={<ServiceAccountCreate />} />
        <Route path={`:serviceaccount/*`} element={<ServiceAccountDetailRoute />} />
      </Routes>
    </Layout>
  );
};

export default observer(ServiceaccountRoute);
